import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import ArticleBody from '../../Blog/ArticleBody';
import localStyles from './styles.less';
import StepContainer from '../StepContainer';

const Terms = ({ acceptedField, privacyField, state, updateContent, title, t }) => (
  <>
    <StepContainer nextButtonDisabled={!(acceptedField && privacyField)}>
      <div className={localStyles.term_text}>
        <div className={localStyles.permision}>
          <ArticleBody title={title} article={state} recommended={false} />
        </div>
      </div>
      <div className={localStyles.textPlaces}>
        <div className={localStyles.flexible}>
          <Checkbox
            onChange={e => updateContent('accepted', e.target.checked)}
            defaultChecked={acceptedField}
            checked={acceptedField}
          >
            <span name="wizard_accepted">{t('wizard.accepted.permision')}</span>
          </Checkbox>
        </div>
        <div className={localStyles.flexible}>
          <Checkbox
            onChange={e => updateContent('privacy', e.target.checked)}
            defaultChecked={privacyField}
            checked={privacyField}
          >
            <span name="wizard_privacy">{t('wizard.privacy.permision')}</span>
          </Checkbox>
        </div>
      </div>
    </StepContainer>
  </>
);
Terms.propTypes = {
  acceptedField: PropTypes.string,
  privacyField: PropTypes.bool,
  state: PropTypes.object,
  updateContent: PropTypes.func,
  title: PropTypes.string,
  t: PropTypes.func,
};

Terms.defaultProps = {
  acceptedField: '',
  privacyField: false,
  state: {},
  updateContent: () => {},
  title: '',
  t: () => {},
};
export default Terms;
